var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "334 -55.4 23 24.5",
    enableBackground: "new 334 -55.4 23 24.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -371.8,
    y: -345,
    width: 969.8,
    height: 713.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "New_Symbol"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 511.5,
    y: 370.4,
    width: 75.1,
    height: 29.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -3.051758e-05)",
    clipPath: "url(#SVGID_4_)"
  }, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    width: 1710,
    height: 1276,
    xlinkHref: "Screen Shot 2014-08-07 at 1.16.05 PM.png",
    transform: "matrix(0.6175 0 0 0.6175 -345.4638 -358.1656)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#575756",
    d: "M352.5-48.3v14.7h-14.1v-14.7h4.5H352.5 M353.2-49h-10.3h-5.2v16.1h15.5V-49L353.2-49z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#575756",
    d: "M342.2-51.8v2.1h-0.9V-51L342.2-51.8 M342.9-53.3l-2.3,2.1v2.3h2.3V-53.3L342.9-53.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#575756",
    d: "M348.7-51.8l0.9,0.8v1.3h-0.9V-51.8 M348-53.3v4.4h2.3v-2.3L348-53.3L348-53.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#575756",
    d: "M346.8-52.6v0.4h-2.7v-0.4H346.8 M347.5-53.3h-4.1v1.8h4.1V-53.3L347.5-53.3z"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "New_Symbol_4"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "New_Symbol_3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.e6bcdee057b7862e6b4536c3bcba641c.svg";
export { ForwardRef as ReactComponent };